const LoaderPaymentReceived = () => {
  return (
    <div className="flex flex-col gap-7 py-4">
      {Array.from({ length: 15 })?.map((_, index) => {
        return (
          <div
            key={index}
            className="grid grid-cols-[1fr_2fr_1fr_1fr_1fr] gap-3 w-full justify-between px-2"
          >
            <div className="bg-gray-300 h-3 w-24 animate-pulse rounded-md"></div>
            <div className="bg-gray-300 h-3 w-28 animate-pulse rounded-md"></div>
            <div className="bg-gray-300 h-3 w-10 animate-pulse rounded-md"></div>
            <div className="bg-gray-300 h-3 w-14 animate-pulse rounded-md"></div>
            <div className="bg-gray-300 h-3 w-40 animate-pulse rounded-md"></div>
          </div>
        );
      })}
    </div>
  );
};

export default LoaderPaymentReceived;
